import * as React from "react";
import { toast } from "react-toastify";

import { useCancelAutomatedRunMutation } from "@/api/contract-family-pipeline";
import { Button } from "@/components/ui/button";
import { getPipelineErrorMessage } from "@/views/contract-families/pipeline/pipelineErrors";

interface Props {
  runId: string;
  className?: string;
}

/** Ends a live automated contract summary run; offered to its requester and to organization administrators. */
export const CancelAutomatedRunButton: React.FC<Props> = ({ runId, className }) => {
  const [cancelRun, { isLoading }] = useCancelAutomatedRunMutation();

  const cancel = async () => {
    try {
      await cancelRun(runId).unwrap();
    } catch (error) {
      toast.error(getPipelineErrorMessage(error));
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={className}
      disabled={isLoading}
      onClick={() => void cancel()}
    >
      {isLoading ? "Cancelling…" : "Cancel"}
    </Button>
  );
};
